import createActionHelper from './createActionHelper';

import {
  SET_USER_TOKEN,
  SET_USER_LOADING,
  SET_USER_ERROR,
  CHANGE_LICENSE_MODAL,
} from '../constants/user';

export function setUserToken(token) {
  return createActionHelper(SET_USER_TOKEN)({
    token,
  });
}

export function setUserLoading(loading) {
  return createActionHelper(SET_USER_LOADING)({
    loading,
  });
}

export function setUserError(error) {
  return createActionHelper(SET_USER_ERROR)({
    error,
  });
}

export function changeLicenseModal(mode) {
  return createActionHelper(CHANGE_LICENSE_MODAL)({
    mode,
  });
}
